import React from 'react';
import { LockIcon, DownloadIcon, ZapIcon } from 'lucide-react';
export function TopUrgencyBar() {
  return <div className="bg-heading text-white py-3 px-4 text-center" data-id="element-284">
      <div className="flex items-center justify-center gap-6 text-sm md:text-base flex-wrap" data-id="element-285">
        <span className="flex items-center gap-2" data-id="element-286">
          <LockIcon className="w-4 h-4" data-id="element-287" />
          Acceso inmediato
        </span>
        <span className="hidden md:inline" data-id="element-288">·</span>
        <span className="flex items-center gap-2" data-id="element-289">
          <DownloadIcon className="w-4 h-4" data-id="element-290" />
          Descarga instantánea
        </span>
        <span className="hidden md:inline" data-id="element-291">·</span>
        <span className="flex items-center gap-2" data-id="element-292">
          <ZapIcon className="w-4 h-4" data-id="element-293" />
          Precio de lanzamiento por tiempo limitado
        </span>
      </div>
    </div>;
}